export default 
[
    // Floor Displacement
    {
        name: 'heightMapTexture',
        type: 'texture',
        path: 'heightmap/heightmap.jpg',
    },
    // Sand Textures
    {
        name: 'sandAmbientOcclusionTexture',
        type: 'texture',
        path: 'textures/sand/ao.jpg',
    },
    {
        name: 'sandColorTexture',
        type: 'texture',
        path: 'textures/sand/color.jpg',
    },
    {
        name: 'sandNormalTexture',
        type: 'texture',
        path: 'textures/sand/normal.jpg',
    },
    {
        name: 'sandRoughnessTexture',
        type: 'texture',
        path: 'textures/sand/roughness.jpg',
    },
    // Texture Ancient Wall
    {
        name: 'ancientWallAOTexture',
        type: 'texture',
        path: 'ancient-walls/ancient-wall-1/ao.jpg',
    },
    {
        name: 'ancientWallColorTexture',
        type: 'texture',
        path: 'ancient-walls/ancient-wall-1/color.jpg',
    },
    {
        name: 'ancientWallHeightTexture',
        type: 'texture',
        path: 'ancient-walls/ancient-wall-1/height.jpg',
    },
    {
        name: 'ancientWallNormalTexture',
        type: 'texture',
        path: 'ancient-walls/ancient-wall-1/normal.jpg',
    },
    {
        name: 'ancientWallRoughnessTexture',
        type: 'texture',
        path: 'ancient-walls/ancient-wall-1/roughness.jpg',
    },
    // Walls Texture
    {
        name: 'wallAOTexture',
        type: 'texture',
        path: 'textures/floor/ao.jpg',
    },
    {
        name: 'wallColorTexture',
        type: 'texture',
        path: 'textures/floor/color.jpg',
    },
    {
        name: 'wallHeightTexture',
        type: 'texture',
        path: 'textures/floor/height.jpg',
    },
    {
        name: 'wallNormalTexture',
        type: 'texture',
        path: 'textures/floor/normal.jpg',
    },
    {
        name: 'wallRoughnessTexture',
        type: 'texture',
        path: 'textures/floor/roughness.jpg',
    },

    // Test if I need a duplicate this textes ::before
    // Alpha Texture
    {
        name: 'doorAlphaTexture',
        type: 'texture',
        path: 'textures/apeture/alpha.jpg',
    },
]